
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.527 9.194a1.052 1.052 0 00-.08.1.506.506 0 00-.06.12.427.427 0 00-.04.12.907.907 0 000 .133.56.56 0 00.053.253.6.6 0 00.36.36.628.628 0 00.507 0 .6.6 0 00.36-.36.667.667 0 00.04-.253.667.667 0 00-1.14-.473zM7 .334a6.667 6.667 0 100 13.333A6.667 6.667 0 007 .333zm0 12A5.334 5.334 0 117 1.666a5.334 5.334 0 010 10.668zm0-8.667a2 2 0 00-1.733 1 .667.667 0 101.153.667.667.667 0 011.051-.139A.667.667 0 017 6.333.667.667 0 006.333 7v.667a.667.667 0 101.334 0v-.12A2 2 0 007 3.667z","fill":"#B1AFCD"}})])
          )
        }
      }
    